module.exports = __webpack_public_path__ + "static/img/WL1350-PF_A.c25ab36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WL1350-PF_A.jpg
// module id = UrCv
// module chunks = 0